// import components
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import { StyledSettingsBox } from './HoursBalanceSettings.styles';

// import hooks
import { useTranslation } from 'react-i18next';

// import types
import type { HoursBalanceImportOptions } from 'generated';
import type { HoursBalanceSettingsProps } from './HoursBalanceSettings.types';

const SETTINGS: {
  key: keyof HoursBalanceImportOptions;
  values: string[];
}[] = [
  { key: 'hoursDirection', values: ['TOO_MANY_WORKED', 'TOO_FEW_WORKED'] },
  { key: 'emptyFieldHandling', values: ['ZERO', 'UNTOUCHED'] },
  { key: 'unlistedEmployeeHandling', values: ['KEEP', 'CLEAR'] }
];

const HoursBalanceSettings = ({
  options,
  onChange,
  disabled
}: HoursBalanceSettingsProps) => {
  'use memo';
  const { t } = useTranslation();

  return (
    <StyledSettingsBox>
      {SETTINGS.map(({ key, values }) => (
        <FormControl key={key}>
          <FormLabel>
            {t(
              `adminPortal.servicedesk.hoursBalanceImport.settings.${key}.label`
            )}
          </FormLabel>
          <RadioGroup
            value={options[key]}
            onChange={(event) =>
              onChange({
                ...options,
                [key]: event.target.value
              } as HoursBalanceImportOptions)
            }
          >
            {values.map((value) => (
              <FormControlLabel
                key={value}
                value={value}
                disabled={disabled}
                control={<Radio />}
                label={t(
                  `adminPortal.servicedesk.hoursBalanceImport.settings.${key}.${value}`
                )}
              />
            ))}
          </RadioGroup>
        </FormControl>
      ))}
    </StyledSettingsBox>
  );
};

export default HoursBalanceSettings;
